const React = require("react");

const baseStyle = {
    backgroundColor: "transparent",
    border: "1px solid #888",
    textTransform: "uppercase"
};

const HollowButton = React.createClass({
    propTypes: {
        style: React.PropTypes.object,
        hoverStyle: React.PropTypes.object,
        onClick: React.PropTypes.func,
        disabled: React.PropTypes.bool
    },
    getDefaultProps() {
        return {
            style: {}
        };
    },
    getInitialState(){
        return {
            hovering: false
        };
    },
    render() {
        const stateStyle = this.GetStateStyle();

        const style = Object.assign({},
            baseStyle,
            stateStyle);

        return (<button className="btn"
                        style={style}
                        onMouseOver={this.HoverOver}
                        onMouseOut={this.HoverOut}
                        onClick={this.props.onClick}
                        disabled={this.props.disabled}>
            {this.props.children}
        </button>)
    },
    HoverOver() {
        this.setState({ hovering: true });
    },
    HoverOut() {
        this.setState({ hovering: false });
    },
    GetStateStyle() {
        if (this.state.hovering) {
            return Object.assign({
                color: "#fff",
                backgroundColor: "rgba(255, 255, 255, .2)"
            }, this.props.style);
        }
        else {
            return Object.assign({
                color: "#fff"
            }, (this.props.hoverStyle || this.props.style)); // In case style wasn't specified
        }
    }
});

module.exports = HollowButton;


// WEBPACK FOOTER //
// ./src/components/HollowButton.jsx